import Cookies from 'js-cookie'

const useAppStore = defineStore(
  'app',
  {
    state: () => ({
      sidebar: {
        opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
        withoutAnimation: false,
        hide: Cookies.get('sidebarHideStatus') ? !!+Cookies.get('sidebarHideStatus') : false
      },
      device: 'desktop',
      size: Cookies.get('size') || 'default'
    }),
    actions: {
      toggleSideBar(withoutAnimation) {
        if (this.sidebar.hide) {
          return false;
        }
        // デスクトップでは 54px アイコンのみの折りたたみ状態を廃止：常にラベル付きの展開状態を維持する
        // （collapse させたい代わりに完全非表示は toggleSideBarHide で対応）。モバイルのドロワー開閉のみ opened をトグルする。
        if (this.device === 'desktop') {
          this.openSideBar()
          return
        }
        this.sidebar.opened = !this.sidebar.opened
        this.sidebar.withoutAnimation = withoutAnimation
        if (this.sidebar.opened) {
          Cookies.set('sidebarStatus', 1)
        } else {
          Cookies.set('sidebarStatus', 0)
        }
      },
      openSideBar(withoutAnimation = false) {
        this.sidebar.opened = true
        this.sidebar.withoutAnimation = withoutAnimation
        Cookies.set('sidebarStatus', 1)
      },
      closeSideBar({ withoutAnimation }) {
        Cookies.set('sidebarStatus', 0)
        this.sidebar.opened = false
        this.sidebar.withoutAnimation = withoutAnimation
      },
      toggleDevice(device) {
        this.device = device
      },
      setSize(size) {
        this.size = size;
        Cookies.set('size', size)
      },
      toggleSideBarHide(status) {
        this.sidebar.hide = status
        Cookies.set('sidebarHideStatus', status ? 1 : 0)
      }
    }
  })

export default useAppStore
